

export class svgDrawer {

    static Triangle(x: number, direction: 'right' | 'left', description: string): string {
        let width: number = 6;
        let height: number = 15;
        if (direction === 'right') {
            width = -width;
        }
        return `<polyline points="${x},${height} ${x-width},${height/2} ${x},0" data-desc="${description}" />`;
    }

    static Line(x: number, strokeWidth: number, height: number, color: string, description: string): string {
        return `<line
        x1="${x}"
        y1="0"
        x2="${x}"
        y2="${height}"
        stroke-width="${strokeWidth}"
        stroke="${color}"
        data-desc="${description}"
        />`;
    }

    static Rect(x: number, width: number, height: number, color: string, description: string): string {
        return `<rect
        x="${x}"
        y="0"
        width="${width}"
        height="${height}"
        fill="${color}"
        data-desc="${description}"
        />`;
    }

}